// `<JobsListPage>` — top-level route at `/app/jobs`.
//
// Composition (UI-SPEC § 4.2 wireframe):
//   GlobalNav (sticky)
//   <main id="main">
//     <JobsList> (5-state controller from Plan 07-02)
//
// Data: useJobs() — TanStack Query, no polling, staleTime 10s.
// Search: client-side substring filter on `address`. State is local React
// state (not URL params per JOBS-01 locked decision — back/forward should
// preserve scroll, not re-trigger filter math).
//
// document.title is synced via a useEffect with cleanup so back-navigation
// restores the previous title (Pitfall reference: PropertyDetail pattern
// from Plan 06-03).

import { useEffect, useState } from 'react';
import { GlobalNav } from '@/components/dashboard/GlobalNav';
import { JobsList as JobsListView } from '@/components/jobs/JobsList';
import { useJobs } from '@/hooks/useJobs';

export function JobsListPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const { data, isLoading, isError, refetch } = useJobs();

  useEffect(() => {
    const previous = document.title;
    document.title = 'Jobs — House Hunter';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <>
      <GlobalNav />
      <main
        id="main"
        className="min-h-screen bg-ocean-950 text-foam-50 px-4 pt-[88px] pb-6 md:px-6 md:pb-8"
      >
        <div className="max-w-[1180px] mx-auto">
          <JobsListView
            jobs={data}
            isLoading={isLoading}
            isError={isError}
            onRetry={() => void refetch()}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />
        </div>
      </main>
    </>
  );
}
